<div class="complex-filter-date-radio-list">
  <form class="form">
    <div class="complex-filter-date-radio-list__items">
      @for (item of filter.options; track item) {
        <div class="complex-filter-date-radio-list__item">
          <ftr-radio
            class="complex-filter-date-radio-list__radio"
            [name]="filter.filterKey"
            [label]="item.key"
            [value]="item.value"
            [control]="internalFormControl"
          ></ftr-radio>
          @if (
            item.value === dateRadioListOptions.SelectDate &&
            internalFormControl.value === dateRadioListOptions.SelectDate
          ) {
            <div class="complex-filter-date-radio-list__template">
              <ftr-date-picker label="Date" [control]="dateControl"></ftr-date-picker>
            </div>
          }
          @if (
            item.value === dateRadioListOptions.SelectDateRange &&
            internalFormControl.value === dateRadioListOptions.SelectDateRange
          ) {
            <div class="complex-filter-date-radio-list__template">
              <ftr-date-picker label="From" [control]="dateRangeFromControl"></ftr-date-picker>
              <ftr-date-picker label="To" [control]="dateRangeToControl"></ftr-date-picker>
            </div>
          }
        </div>
      }
    </div>
  </form>
</div>
